<template>
  <div class="u-scroller u-space--h u-space--large">
    <article
      v-for="journey in journeys"
      :key="journey.id"
      :class="`journey journey--${journey.status}`"
    >
      <h3>{{ journey.from }} to {{ journey.to }}</h3>
      <footer class="u-split">
        <template
          v-if="journey.status === 'in-progress' && $store.getters.yourGo"
        >
          <select
            :value="journey.status"
            @change="
              $store.commit('updateJourney', [journey.id, $event.target.value])
            "
          >
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="forfeited">Forfeited</option>
          </select>
        </template>
        <h5 v-else class="journey__status">{{ journey.status }}</h5>
        <h4 class="journey__score">{{ journey.score }}</h4>
      </footer>
    </article>
  </div>
</template>

<script>
export default {
  computed: {
    journeys() {
      const you = this.$store.getters.you;
      const journeys = Object.keys(you.journeys).map(id => {
        const journey = this.$store.state.journeys.find(
          x => x.id === Number(id)
        );

        return {
          ...journey,
          status: this.$store.getters.you.journeys[id]
        };
      });

      const order = {
        "in-progress": 0,
        completed: 1,
        forfeited: 2
      };

      journeys.sort((a, b) => {
        if (a.status === b.status) return b.score - a.score;
        return order[a.status] - order[b.status];
      });

      return journeys;
    }
  }
};
</script>

<style>
.journey {
  background: #fab1a0;
  width: 220px;
  height: 120px;
  font-size: 0.8em;
  border: 5px solid #fff;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-weight: 700;
  padding: 1em 0.5em 0.5em 1em;
  position: relative;
  margin-bottom: 10px;
  flex-shrink: 0;
}

@media (min-width: 1048px) {
  .journey {
    width: 250px;
    height: 150px;
    font-size: 1em;
  }
}

.journey:after {
  content: "";
  position: absolute;
  z-index: 0;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: url("/bg.jpg") no-repeat center;
  background-size: cover;
  opacity: 0.15;
  pointer-events: none;
}

.journey select {
  font-size: 1em;
}

.journey > * {
  position: relative;
  z-index: 1;
}

.journey--checked {
  border-color: var(--red);
}

.journey__score {
  border: 3px solid rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
  font-weight: 700;
  font-size: 1em;
  border-radius: 100%;
  height: 2em;
  width: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.journey__status {
  text-transform: capitalize;
}

.journey input {
  display: none;
}

.journey--completed {
  background: var(--green);
}

.journey--forfeited {
  background: var(--red);
}
</style>
